import React from "react";
import { Box } from "@mui/material";
import PageHero from "../components/PageHero";
import { saasCanvasSx } from "../components/saasStyles";

export default function PageFrame({ eyebrow, title, description, stats = [], action = null, highlights = [], children }) {
  return (
    <Box sx={{ ...saasCanvasSx, px: 3, pb: 3, pt: { xs: 4.5, lg: 10.5 } }}>
      <PageHero eyebrow={eyebrow} title={title} description={description} stats={stats} action={action} />
      <Box sx={{ display: "grid", gap: 3 }}>{children}</Box>
    </Box>
  );
}
